import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "../history";
import SchemaForm from "./SchemaForm";
import TypeUtils from "../lib/TypeUtils";
import FormUtils from "../lib/FormUtils";
import utils from "../lib/utils";
import { save, remove } from "../actions/content";
import { clear as clearSheets } from "../actions/sheets";

import Loading from "./Loading";
import InfoPopover from "./InfoPopover";
import Switch from "./fields/Switch";

@connect((state, props) => {
  if (props.type && props.model) return {};

  const { params } = props.match;
  const type = state.types.find((type) => type.slug === params.type);

  if (!type || !state.content[type.id]) {
    return {};
  }

  const model = params.id
    ? state.content[type.id].find((c) => c.id === params.id)
    : props.location.state && props.location.state.fromModel
    ? props.location.state.fromModel
    : { active: true };

  return { type, model };
})
export default class EditContent extends Component {
  static contextTypes = {
    site: PropTypes.object.isRequired,
  };

  state = {
    active: this.props.model ? this.props.model.active : false,
    fieldsToValidate: [],
  };

  componentWillReceiveProps(props) {
    if (!props.model) return;

    if (this.props.model !== props.model.active) {
      this.setState({ active: props.model.active });
    }
  }

  getSchema() {
    const { model, type } = this.props;
    if (!type) return null;
    return FormUtils.getContentSchema(type, model);
  }

  validate = async () => {
    const { fieldsToValidate } = this.state;
    await Promise.all(fieldsToValidate.map((field) => field.validate()));
    this.setState({ fieldsToValidate: [] });
  };

  onSubmit = async (value) => {
    const { model, type, isSheet, dispatch, onCreate } = this.props;
    const data = { active: this.state.active, ...value };
    if (model.id) data.id = model.id;

    const {
      data: { content },
    } = await dispatch(save(data, type));

    if (isSheet) {
      dispatch(clearSheets());
      // if part of a "create new", then we send the model back
      onCreate && onCreate(content);
    } else if (!model.id) {
      // new content, redirect to content id
      push(utils.contentUrl(content.id));
    }

    return content;
  };

  validateOnSubmit = (component) => {
    this.setState((prevState) => ({
      fieldsToValidate: [...prevState.fieldsToValidate, component],
    }));
  };

  onDelete = async (e) => {
    e.preventDefault();
    const { model, type, isSheet, dispatch } = this.props;
    await dispatch(remove(model, type));
    if (isSheet) {
      dispatch(clearSheets());
    } else {
      push(utils.contentUrl());
    }
  };

  onChangeActive = (checked) => {
    this.setState({ active: checked });
  };

  onDone = (e) => {
    e.preventDefault();
    const { dispatch, isSheet } = this.props;
    if (isSheet) {
      dispatch(clearSheets());
    } else {
      push(utils.contentUrl());
    }
  };

  render() {
    const schema = this.getSchema();
    const { model, type } = this.props;

    if (!model) {
      return <Loading type="container" />;
    }

    const components = [
      <Switch
        key="active"
        value={this.state.active}
        onChange={this.onChangeActive}
      />,
    ];

    if (model.id) {
      components.push(<InfoPopover key="info" model={model} />);

      const canDelete =
        TypeUtils.can(this.context.site, type, "delete") ||
        TypeUtils.can(this.context.site, type, "delete", model.id);
      if (canDelete) {
        components.push(
          <a
            key="delete"
            className="btn-icon ion-ios-trash-outline btn-delete"
            onClick={this.onDelete}
          />
        );
      }
    }

    return (
      <div className="edit-content scroll-container">
        <SchemaForm
          asyncValidate={this.validate}
          context={{
            validateOnSubmit: this.validateOnSubmit,
          }}
          schema={schema}
          value={model}
          onSubmit={this.onSubmit}
          onCancel={this.onDone}
          actionBar={(props) => components}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/EditContent.js